
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Utwórz kokpit',
	'dashboard': 'Kokpit',
	'dashboardTemplate': 'Szablon kokpitu',
	'createAV': 'Utwórz',
	'createAvEditNameLabel': '1. Nadaj widokowi nazwę',
	'createAvSelectTemplateLabel': '2. Wybierz szablon',
	'tabLayoutLabel': 'Szablon z kartami',
	'infographicsLayoutLabel': 'Szablon infografiki',
	'singlePageLayoutLabel': 'Szablon jednej strony',
	'customLayoutLabel': 'Szablon niestandardowy',
	'freeformTemplate': 'Układ dowolny',
	'freeformTemplateDesc': 'Wizualizacje w układzie dowolnym zachowują wymiary i położenie w widoku, niezależnie od wielkości ekranu. W innych układach wielkość i położenie wizualizacji są dopasowywane do ekranu.',
	'NoTemplate': 'Formularz dowolny',
	'Template1': 'Puste',
	'Template2': 'Tytuł 1 na 2',
	'Template3': '2 nad 1',
	'Template4': '4 nad 1',
	'Template5': 'Stopka 1 na 2',
	'Template6': '3 obok 1 nad 1',
	'Template7': '4 obok 3 nad 1',
	'Template8': '2 nad 3 na 2',
	'Template9': '2 na 2',
	'Template10': '1 na 2 obok 2 na 2 nad 1',
	'Template11': '3 na 1 nad 1 na 2',
	'Template12': '2 nad 1 obok 1 na 2',
	'Template13': 'Jeden obok 1 na 2 obok 1 na 4',
	'Template14': 'Pusty ze strefą upuszczania',
	'Infographics1': 'Puste',
	'Infographics2': '4 wiersze',
	'Infographics3': '4 wiersze z nagłówkami',
	'Infographics4': '2 na 4',
	'Infographics5': 'Duży górny obszar wyświetlania z 2 na 2',
	'Infographics6': '2 na 4 z przerwą w pionie',
	'Infographics7': '2 na 4 w układzie schodkowym',
	'Infographics8': 'Kort tenisowy',
	'Infographics9': '3 na 4',
	'Infographics10': '4 na 8',
	'createAvDashboardLabel': 'Układ',
	'dashboard_template_save_success': 'Twój szablon kokpitu został zapisany.',
	'dashboard_template_prefix': 'Szablon: \'%{name}\'',
	'dashboard_template_filters_removed': 'Filtry z kanwy zostały usunięte.',
	'createAvTabLabel': 'Karty',
	'createAvInfographicsLabel': 'Infografika',
	'createAvSinglepageLabel': 'Jedna strona',
	'createAvCustomLabel': 'Niestandardowe',
	'loadMoreLabel': 'Załaduj więcej...',
	'backLabel': 'Wstecz',
	'addSourceLabel': 'Dodaj źródło',
	'pinLabel': 'Przypnij',
	'errorLoadingDataSetMetaData': 'Wystąpił błąd podczas odczytywania metadanych',
	'errorLoadingDataSets': 'Wystąpił błąd podczas ładowania listy zbiorów danych',
	'errorLoadingDataSet': 'Metadane dla zestawu danych \'%{datasetName}\' nie zostały załadowane. Skontaktuj się z administratorem w sprawie szczegółów.',
	'okButton': 'OK',
	'createButton': 'Utwórz',
	'cancelButton': 'Anuluj',
	'copyButton': 'Kopiuj',
	'selectTemplateLabel': 'Wybierz szablon',
	'noSourcesSelectedLabel': 'Nie wybrano źródeł',
	'find_label': 'Znajdź',
	'noDashboardFound': 'Nie można pobrać kokpitu. Albo już nie istnieje, albo nie masz uprawnień potrzebnych, by go wyświetlić.',
	'errorLabel': 'Błąd',
	'defaultName': 'Nowy kokpit',
	'noDashboardCapability': 'Nie masz możliwości uruchomienia aplikacji kokpitu',
	'noDashboardPermission': 'Nie masz wystarczających uprawnień do wyświetlania tego panelu kontrolnego',
	'sourceNotFound': 'Nie możemy załadować wizualizacji, ponieważ powiązane z nią źródło \'%{sourceName}\' jest niedostępne',
	'cmDuplicateName': 'Element o tej nazwie już istnieje. Wprowadź inna nazwę',
	'cmEmptySelection': 'Kokpit został usunięty. Spróbuj zapisać jako nowy kokpit.',
	'propTheme': 'Kompozycja wizualna',
	'defaultThemeLabel': 'Domyślne',
	'lightThemeLabel': 'Jasna',
	'darkThemeLabel': 'Ciemna',
	'titleTextLabel': 'Tytuł',
	'titleSmallTextLabel': 'Mały tytuł',
	'subtitleTextLabel': 'Podtytuł',
	'bodyTextLabel': 'Treść',
	'bodySmallTextLabel': 'Mała treść',
	'captionTextLabel': 'Podpis',
	'quoteTextLabel': 'Cytat',
	'quoteSmallTextLabel': 'Mały cytat',
	'responsiveTextLabel': 'Automatycznie dopasuj rozmiar',
	'mediaWidgetLabel': 'Multimedia',
	'webpageWidgetLabel': 'Strona WWW',
	'imageWidgetLabel': 'Obraz',
	'textWidgetLabel': 'Tekst',
	'notebookWidgetLabel': 'Notatnik',
	'multipurposeWidgetLabel': 'Wielozadaniowa',
	'textPlaceHolder': 'Tutaj wprowadź tekst',
	'titlePlaceHolder': 'W tym miejscu wprowadź tytuł',
	'toggleEditModeLabel': 'Przełącz do edycji',
	'togglePreviewModeLabel': 'Przełącz do podglądu',
	'editDashboardCoachMarkTitle': 'Edytuj kokpit',
	'editDashboardCoachMarkContents': 'Kliknij ikonę ołówka, aby edytować ten kokpit.',
	'addDataCoachMarkTitle': 'Dodaj dane',
	'addDataDashboardCoachMarkContents': 'Przeciągnij i upuść dane z panelu do kokpitu.',
	'pageSelectWarning': 'Wybierz kartę.',
	'screenshot_label': 'Kokpit %{title}',
	'screenshot_label_tab': 'Karta %{tabName} kokpitu %{title}',
	'dataAssetPropertiesLabel': 'Właściwości wizualizacji',
	'modelFilter': 'Filtr',
	'invertSelectionToolTip': 'Odwróć kryteria filtrowania',
	'clearFilterValueToolTip': 'Wyczyść wartości filtru',
	'invertFilterSelection': 'Odwróć',
	'clearTextFilterValue': 'Wyczyść',
	'filterConditionLabel': 'Warunek filtrowania',
	'applyFilter': 'Zastosuj filtr',
	'itemCountText': 'Wybrane pozycje: %{itemCount}',
	'itemExcludeCountText': 'Liczba wykluczonych pozycji: %{itemCount}',
	'moreMembers': 'Pokaż więcej...',
	'searchHierarchyMembers': 'Użyj wyszukiwania, aby znaleźć elementy...',
	'propHideEmpty': 'Ukryj puste',
	'propColorOrder': 'Znaczenie kolorów',
	'propElementColor': 'Kolor elementu wizualizacji',
	'propLineColor': 'Kolor linii',
	'propLineAndSymbolColor': 'Kolor linii i symbolu',
	'propColumnColor': 'Kolor kolumny',
	'propBarColor': 'Kolor słupka',
	'propWordColor': 'Kolor słowa',
	'propAreaColor': 'Kolor obszaru',
	'propRadialbarColor': 'Kolor słupka na wykresie radialnym',
	'propColorPalettes': 'Palety kolorów',
	'propDashboardColorPalette': 'Bieżąca paleta kokpitu',
	'propNewDashboardPaletteLabel': 'Utwórz niestandardową paletę kokpitu',
	'propDashboardChangePaletteLink': 'Zmień paletę kokpitu',
	'propHideLeafNode': 'Ukryj etykiety wskaźników',
	'propOpacity': 'Krycie',
	'propOpacityDescription': 'Zmień przezroczystość obiektu. Wpisz wartość z przedziału od 0 do 100',
	'addATab': 'Dodaj nową kartę',
	'propFredIsRed': 'Spójność kolorów',
	'areaChartCaption': 'Obszar',
	'areaChartDataSlot_categoriesLabel': 'Etykieta osi',
	'areaChartDataSlot_valuesLabel': 'Wartość',
	'areaChartProp_colorPaletteLabel': 'Palety kolorów',
	'areaChartProp_lineColorLabel': 'Kolor obszaru',
	'areaChartProp_interpolationLabel': 'Wygładź linie',
	'areaChartProp_interpolationDescription': 'Linie łączące punkty danych są zakrzywione.',
	'areaChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'areaChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'areaChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'areaChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'areaChartProp_suppressZerosLabel': 'Ukryj puste',
	'areaChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'barChartCaption': 'Słupkowy',
	'barChartDataSlot_categoriesLabel': 'Etykieta osi',
	'barChartDataSlot_valuesLabel': 'Wartość',
	'barChartProp_colorPaletteLabel': 'Palety kolorów',
	'barChartProp_elementColorLabel': 'Kolor słupka',
	'barChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'barChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'barChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'barChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'barChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'barChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'barChartProp_suppressZerosLabel': 'Ukryj puste',
	'barChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'columnChartCaption': 'Kolumna',
	'columnChartDataSlot_categoriesLabel': 'Etykieta osi',
	'columnChartDataSlot_valuesLabel': 'Wartość',
	'columnChartProp_colorPaletteLabel': 'Palety kolorów',
	'columnChartProp_elementColorLabel': 'Kolor kolumny',
	'columnChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'columnChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'columnChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'columnChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'columnChartProp_suppressZerosLabel': 'Ukryj puste',
	'columnChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'bubbleChartCaption': 'Bąbelkowy',
	'bubbleChartDataSlot_xAxisLabel': 'Oś pozioma',
	'bubbleChartDataSlot_yAxisLabel': 'Oś pionowa',
	'bubbleChartDataSlot_sizeLabel': 'Wielkość wg',
	'bubbleChartDataSlot_colorLabel': 'Kolor wg',
	'bubbleChartProp_colorPaletteLabel': 'Palety kolorów',
	'bubbleChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'bubbleChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'bubbleChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'bubbleChartProp_hideLegendLabel': 'Ukryj legendę',
	'bubbleChartProp_hideLegendDescription': 'Ukryj legendę.',
	'bubbleChartProp_legendPositionLabel': 'Położenie legendy',
	'lineChartCaption': 'Linia',
	'lineChartDataSlot_categoriesLabel': 'Etykieta osi',
	'lineChartDataSlot_valuesLabel': 'Wartość',
	'lineChartProp_colorPaletteLabel': 'Palety kolorów',
	'lineChartProp_lineColorLabel': 'Kolor linii i symbolu',
	'lineChartProp_symbolShapeLabel': 'Kształt symbolu',
	'lineChartProp_hideSymbolsLabel': 'Ukryj symbole',
	'lineChartProp_hideSymbolsDescription': 'Ukryj symbole',
	'lineChartProp_hideDataLinesLabel': 'Ukryj linie',
	'lineChartProp_hideDataLinesDescription': 'Ukryj linie',
	'lineChartProp_interpolationLabel': 'Wygładź linie',
	'lineChartProp_interpolationDescription': 'Linie łączące punkty danych są zakrzywione.',
	'lineChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'lineChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'lineChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'lineChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'lineChartProp_suppressZerosLabel': 'Ukryj puste',
	'lineChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'packedBubbleChart1CatCaption': 'Bąbelkowy upakowany',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorie',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Wielkość wg',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Palety kolorów',
	'packedBubbleChart1CatProp_elementColorLabel': 'Kolor bąbelka',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Ukryj etykietę',
	'packedBubbleChart1CatProp_hideValueLabel': 'Ukryj wartość',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Ukryj puste',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'heatChartCaption': 'Temperatura',
	'heatChartDataSlot_valuesLabel': 'Temperatura wg',
	'heatChartDataSlot_xAxisLabel': 'Oś pozioma',
	'heatChartDataSlot_yAxisLabel': 'Oś pionowa',
	'heatChartProp_colorPaletteLabel': 'Palety kolorów',
	'heatChartProp_heatScalePaletteLabel': 'Znaczenie kolorów',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'heatChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'heatChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'heatChartProp_suppressZerosLabel': 'Ukryj puste',
	'heatChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'heatChartProp_hideLegendLabel': 'Ukryj legendę',
	'heatChartProp_hideLegendDescription': 'Ukryj legendę.',
	'heatChartProp_legendPositionLabel': 'Położenie legendy',
	'pieChartCaption': 'Kołowy',
	'pieChartDataSlot_categoriesLabel': 'Kategorie',
	'pieChartDataSlot_valuesLabel': 'Wartość',
	'pieChartProp_colorPaletteLabel': 'Palety kolorów',
	'pieChartProp_hideRadialValueLabel': 'Ukryj wartość',
	'pieChartProp_pieAsDonutLabel': 'Wyświetlaj jako wykres pierścieniowy',
	'pieChartProp_pieAsDonutDescription': 'Wyświetlaj jako wykres pierścieniowy',
	'pieChartProp_suppressZerosLabel': 'Ukryj puste',
	'pieChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'pieChartProp_hideLegendLabel': 'Ukryj legendę',
	'pieChartProp_hideLegendDescription': 'Ukryj legendę.',
	'pieChartProp_legendPositionLabel': 'Położenie legendy',
	'map1measureCaption': 'Mapa',
	'map1measureDataSlot_categoriesLabel': 'Regiony',
	'map1measureDataSlot_valuesLabel': 'Temperatura w regionie',
	'map1measureProp_colorPaletteLabel': 'Palety kolorów',
	'map1measureProp_heatScalePaletteLabel': 'Znaczenie kolorów',
	'map1measureProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'map1measureProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'map1measureProp_suppressZerosLabel': 'Ukryj puste',
	'map1measureProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'map1measureProp_hideLegendLabel': 'Ukryj legendę',
	'map1measureProp_hideLegendDescription': 'Ukryj legendę.',
	'map1measureProp_legendPositionLabel': 'Położenie legendy',
	'radialChartCaption': 'Radialny',
	'radialChartDataSlot_categoriesLabel': 'Kategorie',
	'radialChartDataSlot_valuesLabel': 'Wartość',
	'radialChartProp_colorPaletteLabel': 'Palety kolorów',
	'radialChartProp_elementColorLabel': 'Kolor słupka na wykresie radialnym',
	'radialChartProp_hideRadialTitleLabel': 'Ukryj tytuł',
	'radialChartProp_hideRadialValueLabel': 'Ukryj wartość',
	'radialChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'radialChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'radialChartProp_suppressZerosLabel': 'Ukryj puste',
	'radialChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'pointChart1catCaption': 'Punkt',
	'pointChart1catDataSlot_valuesLabel': 'Wartość',
	'pointChart1catDataSlot_categoriesLabel': 'Etykieta osi',
	'pointChart1catProp_colorPaletteLabel': 'Palety kolorów',
	'pointChart1catProp_elementColorLabel': 'Kolor kształtu',
	'pointChart1catProp_symbolShapeLabel': 'Kształt symbolu',
	'pointChart1catProp_symbolFillLabel': 'Wypełnij kształt',
	'pointChart1catProp_symbolFillDescription': 'Wyświetlaj kolor wypełnienia dla symboli.',
	'pointChart1catProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'pointChart1catProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'pointChart1catProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'pointChart1catProp_suppressZerosLabel': 'Ukryj puste',
	'pointChart1catProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'scatterPlotChartNoCatCaption': 'Wykres punktowy',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Oś pozioma',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Oś pionowa',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Palety kolorów',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Kolor elementu',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Kształt symbolu',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Wypełnij kształt',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Wyświetlaj kolor wypełnienia dla symboli.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'radialBarChartCaption': 'Słupkowy, radialny',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorie',
	'radialBarChartDataSlot_valuesLabel': 'Wartość',
	'radialBarChartProp_colorPaletteLabel': 'Palety kolorów',
	'radialBarChartProp_elementColorLabel': 'Kolor słupka na wykresie radialnym',
	'radialBarChartProp_hideRadialTitleLabel': 'Ukryj tytuł',
	'radialBarChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'radialBarChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'radialBarChartProp_suppressZerosLabel': 'Ukryj puste',
	'radialBarChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'lineColumnComboChartCaption': 'Wiersz i kolumna',
	'lineColumnComboChartDataSlot_categoryLabel': 'Etykieta osi',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Wartość wiersza',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Wartość kolumny',
	'lineColumnComboChartProp_colorPaletteLabel': 'Palety kolorów',
	'lineColumnComboChartProp_elementColorLabel': 'Kolor kolumny',
	'lineColumnComboChartProp_lineColorLabel': 'Kolor linii i symbolu',
	'lineColumnComboChartProp_symbolShapeLabel': 'Kształt symbolu',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Ukryj symbole',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Ukryj symbole',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Ukryj linie',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Ukryj linie',
	'lineColumnComboChartProp_interpolationLabel': 'Wygładź linie',
	'lineColumnComboChartProp_interpolationDescription': 'Linie łączące punkty danych są zakrzywione.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Ukryj linie siatki',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Ukryj linie siatki',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Ukryj etykiety tytułów osi',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Ukryj tytuły osi.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Ukryj puste',
	'lineColumnComboChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'lineColumnComboChartProp_hideLegendLabel': 'Ukryj legendę',
	'lineColumnComboChartProp_hideLegendDescription': 'Ukryj legendę.',
	'lineColumnComboChartProp_legendPositionLabel': 'Położenie legendy',
	'summaryCaption': 'Podsumowanie',
	'areaName': 'Obszar',
	'areaDescription': 'Obszar',
	'areaDataSlot_colorLabel': 'Kolor wg',
	'areaDataSlot_valuesLabel': 'Wartość',
	'areaDataSlot_categoriesLabel': 'Etykieta osi',
	'bubbleName': 'Bąbelkowy',
	'bubbleDescription': 'Bąbelkowy',
	'bubbleDataSlot_yAxisLabel': 'Oś pionowa',
	'bubbleDataSlot_xAxisLabel': 'Oś pozioma',
	'bubbleDataSlot_sizeLabel': 'Wielkość wg',
	'bubbleDataSlot_colorLabel': 'Kolor wg',
	'clusterBarName': 'Słupkowy',
	'clusterBarDescription': 'Słupkowy',
	'clusterBarDataSlot_colorLabel': 'Kolor wg',
	'clusterBarDataSlot_valuesLabel': 'Wartość',
	'clusterBarDataSlot_categoriesLabel': 'Etykieta osi',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Wartość',
	'clusterColumnName': 'Kolumna',
	'clusterColumnDescription': 'Kolumna',
	'clusterColumnDataSlot_colorLabel': 'Kolor wg',
	'clusterColumnDataSlot_valuesLabel': 'Wartość',
	'clusterColumnDataSlot_categoriesLabel': 'Etykieta osi',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Wartość',
	'clusterLineName': 'Linia',
	'clusterLineDescription': 'Linia',
	'clusterLineDataSlot_colorLabel': 'Kolor wg',
	'clusterLineDataSlot_valuesLabel': 'Oś pionowa',
	'clusterLineDataSlot_categoriesLabel': 'Oś pozioma',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Wartość',
	'gridName': 'Formularz planistyczny',
	'gridDescription': 'Formularz planistyczny',
	'gridDataSlot_grid_colsLabel': 'Kolumna',
	'heatName': 'Temperatura',
	'heatDescription': 'Temperatura',
	'heatDataSlot_yAxisLabel': 'Oś pionowa',
	'heatDataSlot_xAxisLabel': 'Oś pozioma',
	'heatDataSlot_valuesLabel': 'Temperatura wg',
	'lineColumnComboName': 'Wiersz i kolumna',
	'lineColumnComboDescription': 'Wiersz i kolumna',
	'lineColumnComboDataSlot_lineValueLabel': 'Wartość wiersza',
	'lineColumnComboDataSlot_categoryLabel': 'Etykieta osi',
	'lineColumnComboDataSlot_columnValueLabel': 'Wartość kolumny',
	'mapName': 'Wcześniejsza mapa',
	'mapDescription': 'Wcześniejsza mapa',
	'mapDataSlot_sizeLabel': 'Rozmiar punktu',
	'mapDataSlot_valuesLabel': 'Temperatura w regionie',
	'mapDataSlot_sizeHeatLabel': 'Temperatura punktu',
	'mapDataSlot_categoriesLabel': 'Regiony',
	'packedBubbleName': 'Bąbelkowy upakowany',
	'packedBubbleDescription': 'Bąbelkowy upakowany',
	'packedBubbleDataSlot_sizeLabel': 'Wielkość wg',
	'packedBubbleDataSlot_colorLabel': 'Kolor wg',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorie',
	'pieName': 'Kołowy',
	'pieDescription': 'Kołowy',
	'pieDataSlot_valuesLabel': 'Wartość',
	'pieDataSlot_categoriesLabel': 'Kategorie',
	'playerName': 'Odtwarzacz danych',
	'playerDescription': 'Odtwarzacz danych',
	'playerDataSlot_categoriesLabel': 'Etykieta osi',
	'pointName': 'Punkt',
	'pointDescription': 'Punkt',
	'pointDataSlot_colorLabel': 'Kolor wg',
	'pointDataSlot_valuesLabel': 'Wartość',
	'pointDataSlot_categoriesLabel': 'Etykieta osi',
	'radialName': 'Radialny',
	'radialDescription': 'Radialny',
	'radialDataSlot_valuesLabel': 'Wartość',
	'radialDataSlot_maxSizeLabel': 'Wartość maksymalna',
	'radialDataSlot_categoriesLabel': 'Kategorie',
	'radialBarName': 'Słupkowy, radialny',
	'radialBarDescription': 'Słupkowy, radialny',
	'radialBarDataSlot_valuesLabel': 'Wartość',
	'radialBarDataSlot_categoriesLabel': 'Kategorie',
	'scatterPlotName': 'Wykres punktowy',
	'scatterPlotDescription': 'Wykres punktowy',
	'scatterPlotDataSlot_yAxisLabel': 'Oś pionowa',
	'scatterPlotDataSlot_xAxisLabel': 'Oś pozioma',
	'scatterPlotDataSlot_colorLabel': 'Kolor wg',
	'scatterPlotDataSlot_categoriesLabel': 'Punkty',
	'stackedBarName': 'Słupkowy skumulowany',
	'stackedBarDescription': 'Słupkowy skumulowany',
	'stackedBarDataSlot_colorLabel': 'Kolor wg',
	'stackedBarDataSlot_valuesLabel': 'Wartość',
	'stackedBarDataSlot_categoriesLabel': 'Etykieta osi',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Wartość',
	'stackedColumnName': 'Kolumnowy skumulowany',
	'stackedColumnDescription': 'Kolumnowy skumulowany',
	'stackedColumnDataSlot_colorLabel': 'Kolor wg',
	'stackedColumnDataSlot_valuesLabel': 'Wartość',
	'stackedColumnDataSlot_categoriesLabel': 'Etykieta osi',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Wartość',
	'summaryChartName': 'Podsumowanie',
	'summaryChartDescription': 'Podsumowanie',
	'summaryChartDataSlot_valuesLabel': 'Wartość',
	'treeMapName': 'Mapa drzewa',
	'treeMapDescription': 'Mapa drzewa',
	'treeMapDataSlot_colorLabel': 'Temperatura wg',
	'treeMapDataSlot_valuesLabel': 'Wielkość wg',
	'treeMapDataSlot_categoriesLabel': 'Poziom pierwszy',
	'treeMapDataSlot_level3Label': 'Poziom trzeci',
	'treeMapDataSlot_level2Label': 'Poziom drugi',
	'wordCloudName': 'Chmura słów',
	'wordCloudDescription': 'Chmura słów',
	'wordCloudDataSlot_colorLabel': 'Kolor wg',
	'wordCloudDataSlot_scaleLabel': 'Wielkość wg',
	'wordCloudDataSlot_wordLabel': 'Słowa',
	'treeMap1Cat1MeasureChartCaption': 'Mapa drzewa',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Poziom pierwszy',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Wielkość wg',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Palety kolorów',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Ukryj puste',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Ukryj legendę',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Ukryj legendę.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Położenie legendy',
	'wordChart1Cat1MeasureCaption': 'Chmura słów',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Słowa',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Wielkość wg',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Palety kolorów',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Kolor słowa',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Zachowaj skalę osi',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Zawsze wyświetlaj na osiach wartości minimalne i maksymalne.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Ukryj puste',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Ukryj kategorie bez powiązanych wartości.',
	'missingDataSetData': 'Dane tego zestawu danych nie są dostępne. Odśwież zestaw danych lub skontaktuj się z administratorem w sprawie dostępu do źródła.',
	'hideShowSummaries': 'Ukryj/pokaż podsumowania',
	'crosstabName': 'Tabela przestawna',
	'value_is_not_available': 'Nie dotyczy',
	'swapRowsAndColumns': 'Zamień wiersze i kolumny',
	'NoPinsCollected': 'Brak przypiętych wizualizacji',
	'pinSearchOld': 'Szukaj moich przypięć',
	'pinDeletedToast': 'Przypięcie zostało usunięte',
	'pinAddedToast': 'Przypięcie zostało pomyślnie dodane do obszaru Moje przypięcia',
	'pinRetrieveError': 'Nie można pobrać jednego lub większej liczby przypięć. Spróbuj ponownie później.',
	'pinErrorTitle': 'Błąd przypinania',
	'pinRemove': 'Skasuj przypięcie',
	'deletePin': 'Usuń przypięcie',
	'dataset_time': 'godzina',
	'dataset_date': 'data',
	'dataset_location': 'lokalizacja',
	'dataset_number': 'liczba',
	'dataset_text': 'tekst',
	'widgetConditionalFormatLabel': 'Przełączaj elementy warunkowego sterowania formatami',
	'deletePinConfirmationMessage': 'Czy na pewno chcesz usunąć to przypięcie? Tej operacji nie można cofnąć.',
	'deletePinConfirm': 'Potwierdź usunięcie',
	'pinDeleteError': 'Nie można usunąć jednego lub większej liczby przypięć. Spróbuj ponownie później.',
	'conditionalPalettePickerLabel': 'Rozkład wartości %{title}',
	'HistogramYAxisTitle': 'Liczebność',
	'metadataPickerTitle': 'Utwórz zestaw danych',
	'moreTitle': 'Więcej',
	'remove_slider_handle': 'Usuń uchwyt',
	'missingFiltering': 'Brak kolumny:',
	'unSupportedPromptType': 'Scenariusz pytania nie jest aktualnie obsługiwany.',
	'preAggregateLabel': 'Zastosuj wartości pytań ze źródła danych',
	'postAggregateLabel': 'Zastosuj wartości pytań w raporcie',
	'preAggregateText': 'W zakresie używane są wartości ze źródła danych, a nie wartości wyświetlane w kokpicie.',
	'tabName_general': 'Ogólne',
	'tabName_visDetails': 'Szczegóły',
	'tabName_textDetails': 'Szczegóły tekstu',
	'tabName_mediaDetails': 'Szczegóły multimediów',
	'tabName_webDetails': 'Szczegóły strony WWW',
	'tabName_imageDetails': 'Szczegóły obrazu',
	'tabName_visualization': 'Wizualizacja',
	'sectionName_canvas': 'Kanwa',
	'sectionName_colorsAndThemes': 'Kolor i kompozycja',
	'sectionName_appearance': 'Wygląd',
	'sectionName_advanced': 'Zaawansowane',
	'sectionName_layout': 'Układ',
	'sectionName_tabs': 'Karty',
	'sectionName_tabTitle': 'Etykieta',
	'sectionName_tabBackground': 'Tło',
	'addDataSourceDialogTitle': 'Dodaj źródło danych',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'shapesDoubleChevron': 'Podwójny szewron',
	'widgetsPanelTitle': 'Widgety',
	'widgetsPanelImageLibraryTab': 'Biblioteka obrazów',
	'widgetsPanelSectionBasic': 'Podstawowe',
	'widgetsPanelSectionAdvanced': 'Zaawansowane',
	'widgetsPanelSectionShapes': 'Kształty',
	'customWidgetsTitle': 'Widgety niestandardowe',
	'filterItemCanvasMove': 'Dodaj do kanwy',
	'filterOverflowMenu_Global': 'Menu rozszerzone wszystkich kart',
	'filterOverflowMenu_Tab': 'Menu rozszerzone tej karty',
	'filterOverflowMenu_Item': 'Menu rozszerzone filtra',
	'filterOverflowMenu_Single': 'Menu rozszerzone',
	'filterItemEdit': 'Edytuj wartości filtru',
	'filterDeleteAllItems': 'Usuń wszystkie filtry',
	'filterClearAllItems': 'Wyczyść wszystkie filtry',
	'filterClearSelection': 'Wyczyść filtr',
	'filterPlayerMode': 'Pokaż odtwarzacz',
	'filterStaticMode': 'Pokaż listę',
	'filterInvertSelection': 'Odwróć filtr',
	'filterIconLabel_Global': 'Wszystkie karty',
	'filterIconLabel_Single': 'Filtry',
	'filterIconLabel_Tab': 'Ta karta',
	'filterIconTooltip_Global': 'Wszystkie karty',
	'filterIconTooltip_Tab': 'Ta karta',
	'filterIconTooltip_Single': 'Filtry',
	'filterItemDelete': 'Usuń filtr',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'wszystko z wyjątkiem: %{from}-%{to}',
	'filterExcept': 'z wyjątkiem %{values}',
	'filterAll': 'Wszystko',
	'filterBlank': '(wartość pusta)',
	'filterDisableRangeInvert': 'Niedostępne, gdy ta kolumna znajduje się w filtrze \'Wszystkie karty\'.',
	'filterDisableHierarchyInvert': 'Niedostępne, gdy ta kolumna jest filtrem hierarchii.',
	'filterSelectedOfTotal': '%{selected} z %{totalMembers}',
	'filter_date_before': 'Przed %{to}',
	'filter_date_before_except': 'Nie przed %{to}',
	'filter_date_after': 'Po %{from}',
	'filter_date_after_except': 'Nie po %{from}',
	'filter_date_between': 'Między %{from}-%{to}',
	'filter_date_between_except': 'Nie między %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować wszystkie karty.',
	'filter_drag_and_drop_current_tab': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować tę kartę.',
	'filter_drag_and_drop_single_dock': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować.',
	'errMsgFilterItemGenericTitle': 'Nie można załadować wartości filtru',
	'widgetChromeRotate': 'Obróć',
	'toolbarRegionLabel': 'Pasek narzędzi',
	'toolbarActionDelete': 'Usuń',
	'toolbarActionGroup': 'Grupa',
	'toolbarActionUngroup': 'Rozgrupuj',
	'toolbarActionOrderToFront': 'Przesuń na pierwszy plan',
	'toolbarActionOrderToBack': 'Przesuń na ostatni plan',
	'toolbarActionEditTitle': 'Edytuj tytuł',
	'toolbarActionWrapTitle': 'Zawijaj tytuł',
	'toolbarActionPin': 'Zbierz',
	'toolbarActionPinOld': 'Przypnij',
	'toolbarActionAlign': 'Wyrównaj',
	'alignWidgetLeft': 'Po lewej',
	'alignWidgetCenter': 'Wyśrodkowanie',
	'alignWidgetRight': 'Po prawej',
	'alignWidgetTop': 'U góry',
	'alignWidgetMiddle': 'Pośrodku',
	'alignWidgetBottom': 'U dołu',
	'toolbarChangeVisualization': 'Zmień wizualizację',
	'live_label': 'Wykres',
	'filter_label': 'Filtr',
	'one_named_live': 'Wykres %{name}',
	'one_named_live_numbered': 'Wykres %{name} (%{number})',
	'one_unknown_live': 'Wykres',
	'one_unknown_live_numbered': 'Wykres (%{number})',
	'few_live': 'Grupa %{count} wykresów',
	'many_live': 'Grupa %{count} wykresów',
	'one_custom': 'Widget niestandardowy',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtr %{name}',
	'one_named_filter_numbered': 'Filtr %{name} (%{number})',
	'one_unknown_filter': 'Filtr',
	'one_unknown_filter_numbered': 'Filtr (%{number})',
	'few_filter': 'Grupa %{count} filtrów',
	'many_filter': 'Grupa %{count} filtrów',
	'LIVE_bar_has_mapping': 'Wykres słupkowy %{values}',
	'LIVE_bar_has_mapping_numbered': 'Wykres słupkowy %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Wykres słupkowy %{categories} na %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Wykres słupkowy %{categories} na %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Pusty wykres słupkowy',
	'LIVE_bar_no_mapping_numbered': 'Pusty wykres słupkowy (%{number})',
	'LIVE_bar_named': 'Wykres słupkowy %{name}',
	'LIVE_bar_named_numbered': 'Wykres słupkowy %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Skumulowany wykres słupkowy %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Skumulowany wykres słupkowy %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Skumulowany wykres słupkowy %{categories} na %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Skumulowany wykres słupkowy %{categories} na %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Pusty skumulowany wykres słupkowy',
	'LIVE_stacked_bar_no_mapping_numbered': 'Pusty skumulowany wykres słupkowy (%{number})',
	'LIVE_stacked_bar_named': 'Skumulowany wykres słupkowy %{name}',
	'LIVE_stacked_bar_named_numbered': 'Skumulowany wykres słupkowy %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Wykres bąbelkowy %{categories} na %{x} i %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Wykres bąbelkowy %{categories} na %{x} i %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Pusty wykres bąbelkowy',
	'LIVE_bubble_no_mapping_numbered': 'Pusty wykres bąbelkowy (%{number})',
	'LIVE_bubble_named': 'Wykres bąbelkowy %{name}',
	'LIVE_bubble_named_numbered': 'Wykres bąbelkowy %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Wykres złożony %{categories} na %{columnValue} i %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Wykres złożony %{categories} na %{columnValue} i %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Pusty wykres złożony',
	'LIVE_composite_no_mapping_numbered': 'Pusty wykres złożony (%{number})',
	'LIVE_composite_named': 'Wykres złożony %{name}',
	'LIVE_composite_named_numbered': 'Wykres złożony %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Drzewo decyzyjne %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Drzewo decyzyjne %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Puste drzewo decyzyjne',
	'LIVE_decision_tree_no_mapping_numbered': 'Puste drzewo decyzyjne (%{number})',
	'LIVE_decision_tree_named': 'Drzewo decyzyjne %{name}',
	'LIVE_decision_tree_named_numbered': 'Drzewo decyzyjne %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Upakowany wykres bąbelkowy %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Upakowany wykres bąbelkowy %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Pusty upakowany wykres bąbelkowy',
	'LIVE_packed_bubble_no_mapping_numbered': 'Pusty upakowany wykres bąbelkowy (%{number})',
	'LIVE_packed_bubble_named': 'Upakowany wykres bąbelkowy %{name}',
	'LIVE_packed_bubble_named_numbered': 'Upakowany wykres bąbelkowy %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Wykres kołowy %{categories} na %{values}',
	'LIVE_pie_has_mapping_numbered': 'Wykres kołowy %{categories} na %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Pusty wykres kołowy',
	'LIVE_pie_no_mapping_numbered': 'Pusty wykres kołowy (%{number})',
	'LIVE_pie_named': 'Wykres kołowy %{name}',
	'LIVE_pie_named_numbered': 'Wykres kołowy %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Wykres pierścieniowy %{categories} na %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Wykres pierścieniowy %{categories} na %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Pusty wykres pierścieniowy',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Pusty wykres pierścieniowy (%{number})',
	'LIVE_pie_as_donut_named': 'Wykres pierścieniowy %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Wykres pierścieniowy %{name} (%{number})',
	'LIVE_line_has_mapping': 'Wykres liniowy %{categories} na %{values}',
	'LIVE_line_has_mapping_numbered': 'Wykres liniowy %{categories} na %{values} (%{number})',
	'LIVE_line_no_mapping': 'Pusty wykres liniowy',
	'LIVE_line_no_mapping_numbered': 'Pusty wykres liniowy (%{number})',
	'LIVE_line_named': 'Wykres liniowy %{name}',
	'LIVE_line_named_numbered': 'Wykres liniowy %{name} (%{number})',
	'LIVE_area_has_mapping': 'Wykres warstwowy %{categories} na %{values}',
	'LIVE_area_has_mapping_numbered': 'Wykres warstwowy %{categories} na %{values} (%{number})',
	'LIVE_area_no_mapping': 'Pusty wykres warstwowy',
	'LIVE_area_no_mapping_numbered': 'Pusty wykres warstwowy (%{number})',
	'LIVE_area_named': 'Wykres warstwowy %{name}',
	'LIVE_area_named_numbered': 'Wykres warstwowy %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Skumulowany procentowy wykres warstwowy %{categories} na %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Skumulowany procentowy wykres warstwowy %{categories} na %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Pusty skumulowany procentowy wykres warstwowy',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Pusty skumulowany procentowy wykres warstwowy (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Skumulowany procentowy wykres warstwowy %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Skumulowany procentowy wykres warstwowy %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Mapa natężeń %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Mapa natężeń %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Pusta mapa natężeń',
	'LIVE_heatmap_no_mapping_numbered': 'Pusta mapa natężeń (%{number})',
	'LIVE_heatmap_named': 'Mapa natężeń %{name}',
	'LIVE_heatmap_named_numbered': 'Mapa natężeń %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Sieć %{categories} na %{series} i %{values}',
	'LIVE_network_opt_mapping_numbered': 'Sieć %{categories} na %{series} i %{values} (%{number})',
	'LIVE_network_has_mapping': 'Sieć %{categories} na %{series}',
	'LIVE_network_has_mapping_numbered': 'Sieć %{categories} na %{series} (%{number})',
	'LIVE_network_no_mapping': 'Pusta sieć',
	'LIVE_network_no_mapping_numbered': 'Pusta sieć (%{number})',
	'LIVE_network_named': 'Sieć %{name}',
	'LIVE_network_named_numbered': 'Sieć %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Radialny wykres słupkowy %{categories} na %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Radialny wykres słupkowy %{categories} na %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Radialny wykres słupkowy %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Radialny wykres słupkowy %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Pusty radialny wykres słupkowy',
	'LIVE_radial_bar_no_mapping_numbered': 'Pusty radialny wykres słupkowy (%{number})',
	'LIVE_radial_bar_named': 'Radialny wykres słupkowy %{name}',
	'LIVE_radial_bar_named_numbered': 'Radialny wykres słupkowy %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Wykres spiralny %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Wykres spiralny %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Pusty wykres spiralny',
	'LIVE_spiral_no_mapping_numbered': 'Pusty wykres spiralny (%{number})',
	'LIVE_spiral_named': 'Wykres spiralny %{name}',
	'LIVE_spiral_named_numbered': 'Wykres spiralny %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Mapa drzewa %{categories} na %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Mapa drzewa %{categories} na %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Pusta mapa drzewa',
	'LIVE_treemap_no_mapping_numbered': 'Pusta mapa drzewa (%{number})',
	'LIVE_treemap_named': 'Mapa drzewa %{name}',
	'LIVE_treemap_named_numbered': 'Mapa drzewa %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Chmura słów %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Chmura słów %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Pusta chmura słów',
	'LIVE_wordcloud_no_mapping_numbered': 'Pusta chmura słów (%{number})',
	'LIVE_wordcloud_named': 'Chmura słów %{name}',
	'LIVE_wordcloud_named_numbered': 'Chmura słów %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Odtwarzacz danych %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Odtwarzacz danych %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Pusty odtwarzacz danych',
	'LIVE_data_player_no_mapping_numbered': 'Pusty odtwarzacz danych (%{number})',
	'LIVE_data_player_named': 'Odtwarzacz danych %{name}',
	'LIVE_data_player_named_numbered': 'Odtwarzacz danych %{name} (%{number})',
	'LIVE_map_has_mapping': 'Mapa %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mapa %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Pusta mapa',
	'LIVE_map_no_mapping_numbered': 'Pusta mapa (%{number})',
	'LIVE_map_named': 'Mapa %{name}',
	'LIVE_map_named_numbered': 'Mapa %{name} (%{number})',
	'LIVE_point_has_mapping': 'Schemat punktowy %{categories} na %{values}',
	'LIVE_point_has_mapping_numbered': 'Schemat punktowy %{categories} na %{values} (%{number})',
	'LIVE_point_no_mapping': 'Pusty schemat punktowy',
	'LIVE_point_no_mapping_numbered': 'Pusty schemat punktowy (%{number})',
	'LIVE_point_named': 'Schemat punktowy %{name}',
	'LIVE_point_named_numbered': 'Schemat punktowy %{name} (%{number})',
	'LIVE_column_has_mapping': 'Wykres kolumnowy %{values}',
	'LIVE_column_has_mapping_numbered': 'Wykres kolumnowy %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Wykres kolumnowy %{categories} na %{values}',
	'LIVE_column_opt_mapping_numbered': 'Wykres kolumnowy %{categories} na %{values} (%{number})',
	'LIVE_column_no_mapping': 'Pusty wykres kolumnowy',
	'LIVE_column_no_mapping_numbered': 'Pusty wykres kolumnowy (%{number})',
	'LIVE_column_named': 'Wykres kolumnowy %{name}',
	'LIVE_column_named_numbered': 'Wykres kolumnowy %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Skumulowany wykres kolumnowy %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Skumulowany wykres kolumnowy %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Skumulowany wykres kolumnowy %{categories} na %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Skumulowany wykres kolumnowy %{categories} na %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Pusty skumulowany wykres kolumnowy',
	'LIVE_stacked_column_no_mapping_numbered': 'Pusty skumulowany wykres kolumnowy (%{number})',
	'LIVE_stacked_column_named': 'Skumulowany wykres kolumnowy %{name}',
	'LIVE_stacked_column_named_numbered': 'Skumulowany wykres kolumnowy %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Wykres punktowy %{categories} na %{x} i %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Wykres punktowy %{categories} na %{x} i %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Wykres punktowy %{x} wobec %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Wykres punktowy %{x} wobec %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Pusty wykres punktowy',
	'LIVE_scatter_no_mapping_numbered': 'Pusty wykres punktowy (%{number})',
	'LIVE_scatter_named': 'Wykres punktowy %{name}',
	'LIVE_scatter_named_numbered': 'Wykres punktowy %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Wykres wodospadowy %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Wykres wodospadowy %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Pusty wykres wodospadowy',
	'LIVE_waterfall_no_mapping_numbered': 'Pusty wykres wodospadowy (%{number})',
	'LIVE_waterfall_named': 'Wykres wodospadowy %{name}',
	'LIVE_waterfall_named_numbered': 'Wykres wodospadowy %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Utwórz wizualizację',
	'LIVE_empty_visualization_hint_description': 'Przeciągnij i upuść kolumny tutaj lub w miejscach po lewej stronie.',
	'LIVE_slots_required_field_description': '%{asterisk} Oznacza pole wymagane',
	'LIVE_slots_drag_and_drop_description': 'Przeciągnij i upuść dane w powyższych miejscach, aby utworzyć i przefiltrować wizualizację.',
	'requiredField': 'Pole wymagane',
	'fullScreenEnter': 'Tryb pełnoekranowy',
	'fullScreenClose': 'Wyjdź z trybu pełnoekranowego',
	'noExtraText_multipurpose': 'Uniwersalny obiekt zastępczy',
	'noExtraText_multipurpose_numbered': 'Uniwersalny obiekt zastępczy (%{number})',
	'one_placeholder_vis': 'Obiekt zastępczy wizualizacji',
	'one_placeholder_vis_numbered': 'Obiekt zastępczy wizualizacji (%{number})',
	'one_placeholder_text': 'Obiekt zastępczy tekstu',
	'one_placeholder_text_numbered': 'Obiekt zastępczy tekstu (%{number})',
	'few_placeholder_text': 'Grupa %{count} obiektów zastępczych tekstu',
	'many_placeholder_text': 'Grupa %{count} obiektów zastępczych tekstu',
	'filter_includesAll': 'Uwzględnia wszystkie',
	'timeline_filter_moved_to': 'Filtr diagramu chronologicznego %{id} przeniesiono do %{time}',
	'timelineSettingsButton': 'Opcje odtwarzania',
	'autoPlay': 'Odtwórz wszystkie sceny',
	'loop': 'Pętla',
	'noSceneTransitionLabel': 'Brak',
	'sceneTransitionPropertyLabel': 'Przejście sceny',
	'animatedPathSceneTransitionLabel': 'Ścieżka animowana',
	'sweepSceneTransitionLabel': 'Przebieg',
	'propAniAnimation': 'Animacja',
	'propAniTypeEntrance': 'Animacja wejściowa',
	'propAniDirectionIn': 'Kierunek wejścia',
	'propAniTypeExit': 'Animacja wyjściowa',
	'propAniDirectionOut': 'Kierunek wyjścia',
	'propAniDirection': 'Kierunek',
	'timelineAnimationProperties': 'Otwórz właściwości animacji',
	'editStoryCoachMarkTitle': 'Edytuj scenariusz',
	'editStoryCoachMarkContents': 'Kliknij ikonę ołówka, aby edytować ten scenariusz.',
	'addDataStoryCoachMarkContents': 'Przeciągnij i upuść dane z panelu do scenariusza.',
	'expandSceneCoachmarkTitle': 'Otwórz oś czasu',
	'expandSceneCoachmarkContents': 'Animuj scenę, dostosowując widoczność obiektu na podstawie czasu i czasu trwania.',
	'overviewCoachmarkTitle': 'Sceny przeglądu',
	'overviewCoachmarkContents': 'Użyj scen przeglądu na początku i na końcu scenariusza, aby wyświetlić obraz wszystkich scen. W obszarze scen przeglądu kliknij i przeciągnij scenę, aby zamienić kolejność pomiędzy scenami. Sceny przeglądu można wyświetlać lub ukrywać we właściwościach scenariusza.',
	'animatedPathCoachmarkTitle': 'Ścieżka animowana',
	'animatedPathCoachmarkContents': 'Aby animować ruch obiektu z jednej sceny do drugiej, zduplikuj scenę z obiektem. Następnie w nowej scenie przesuń lub obróć zduplikowany obiekt bądź zmień jego wielkość.',
	'tabName_animation': 'Animacja',
	'textWidgetIconPlaceholderText': 'Kliknij, aby dodać tekst',
	'visIconPlaceholderText': 'Przeciągaj i upuszczaj dane w celu zbudowania wizualizacji',
	'launchNewExplore': 'Nowa eksploracja',
	'addTo': 'Dodaj do',
	'addToExisting': 'Dodaj do istniejącej...',
	'exploreData': 'Eksploruj',
	'explore_remove_widget_styles': 'Właściwości wizualizacji niestandardowej, takie jak ustawienia koloru, nie są utrwalone w eksploracji.',
	'editNotebook': 'Edytuj widget',
	'thumbnails_error_fetching': 'Błąd podczas pobierania miniatur',
	'copy': 'Liczba skopiowanych zasobów: %{count}',
	'specConvertErr': 'Wystąpił błąd podczas wklejania lub przekształcania specyfikacji kokpitu.',
	'specCopyErr': 'Błąd podczas kopiowania specyfikacji kokpitu',
	'pasteNotSupportedErr': 'Wklejanie z %{name} nie jest obsługiwane.',
	'reportParam': 'Raport',
	'filterWidgetCopyWarn': 'Wizualizacja filtru nie została skopiowana, ponieważ filtry nie są obecnie obsługiwane.',
	'upgradingDashboard': 'Aktualizowanie \'%{name}\' dla %{version}...',
	'upgradeComplete': 'Aktualizacja zakończona',
	'individualTabProperties': 'Właściwości poszczególnych kart',
	'propMasterTabStylesLabel': 'Styl karty głównej',
	'propTabPosition': 'Pozycja karty',
	'propTabTitle': 'Tytuł',
	'propTabBackgroundColor': 'Kolor wypełnienia',
	'propTabTextColor': 'Kolor tytułu',
	'propTabSelectedBarColor': 'Kolor wybranego słupka',
	'propTabRestoreDefaults': 'Odtwórz wartości domyślne',
	'propIndividualTabStylesLabel': 'Styl poszczególnych kart',
	'propIndividualTabStylesAriaLabel': 'Otwórz właściwości stylu poszczególnych kart',
	'propTabIconPosition': 'Pozycja ikony',
	'propLeftTitle': 'Z lewej strony tytułu',
	'propRightTitle': 'Z prawej strony tytułu',
	'propTopTitle': 'Nad tytułem',
	'propBottomTitle': 'Pod tytułem',
	'propTabIconLabel': 'Wizualne',
	'propTabIcon': 'Ikona',
	'propTabIconColor': 'Kolor ikony',
	'no_icon': 'Puste',
	'announcement': 'Ogłoszenie',
	'api': 'Interfejs API',
	'archive': 'Archiwizuj',
	'asset': 'Zasób',
	'attachment': 'Załącznik',
	'audio': 'Dźwięk',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Zakładka',
	'calendar': 'Kalendarz',
	'camera': 'Aparat',
	'capability': 'Możliwość',
	'catalog': 'Katalog',
	'chat_message': 'Wiadomość czatu',
	'checkout_cart': 'Wózek przy kasie',
	'client': 'Klient',
	'clock': 'Zegar',
	'cloud': 'Chmury',
	'code': 'Kod',
	'data_quality': 'Jakość danych',
	'folder': 'Foldery',
	'forum': 'Forum',
	'glasses': 'Okulary',
	'group': 'Grupa',
	'hat': 'Kapelusz',
	'headphone': 'Słuchawki',
	'hills': 'Wzgórza',
	'home': 'Strona główna',
	'idea': 'Pomysł',
	'image': 'Obraz',
	'inventory': 'Zapasy',
	'like': 'Polubienie',
	'link': 'Odsyłacz',
	'location': 'Lokalizacja',
	'manage': 'Zarządzaj',
	'pen': 'Pióro',
	'mobile_phone': 'Numer telefonu komórkowego',
	'music': 'Muzyka',
	'notifications': 'Powiadomienia',
	'paint': 'Farba',
	'payment': 'Płatność',
	'password_key': 'Klucz hasła',
	'people': 'Ludzie',
	'person': 'Osoba',
	'phone': 'Telefon',
	'pin': 'Przypnij',
	'print': 'Drukuj',
	'recording': 'Nagranie',
	'repository': 'Repozytorium',
	'role': 'Rola',
	'search': 'Szukaj',
	'properties': 'Właściwości',
	'speaker': 'Głośnik',
	'star': 'Gwiazda',
	'tag': 'Znacznik',
	'thumbs_up': 'Kciuk w górę',
	'thumbs_down': 'Kciuk w dół',
	'tools': 'Narzędzia',
	'traffic': 'Ruch',
	'trash': 'Kosz',
	'twitter': 'Twitter',
	'unknown': 'Nieznane',
	'user': 'Użytkownik',
	'venn_diagram': 'Diagram Venna',
	'video': 'Wideo',
	'view': 'Widok',
	'warning': 'Ostrzeżenie',
	'watch': 'Obejrzyj',
	'watson': 'Watson',
	'wikis': 'Obszary wiki',
	'workspace': 'Obszar roboczy',
	'world': 'Świat',
	'OnLoadFilterModifierDatasourceMismatch': 'Filtry nie będą stosowane względem celu, ponieważ kokpity korzystają z różnych źródeł.',
	'OnLoadFilterModifierColumnMismatch': 'Co najmniej jeden z filtrów nie został zastosowany, ponieważ nie znaleziono dopasowanych kolumn.',
	'eventGroupButtonLabel': 'Wyświetl połączenia widgetów',
	'dockToolbar': 'Zadokuj pasek narzędzi',
	'undockToolbar': 'Odłącz pasek narzędzi',
	'propShowTitle': 'Pokaż tytuł'
});
